/* eslint-disable no-array-constructor */
// import store from '@/store/store'
// import apiCentralSeguranca from '@/api/centralseguranca'

export default {
  itens: [
    {
      name: 'Cerro',
      url: '#',
      icon: 'fas fa-pen',
      children: [
        {
          name: 'Consulta Pendências',
          url: '/cerro/ConsPendCerroAcorr'
        }
        // {
        //   name: 'Consultar',
        //   url: '/usuario/consultar'
        // }
      ]
    },
    {
      name: 'Vincular UGA/Recolhimento',
      url: '/gprunica/ConsVincCodRecolhimento',
      icon: 'fas fa-file',
      children: [
        {
          name: 'Consulta Vinculação Códigos de Recolhimento/ Receitas',
          url: '/gprunica/ConsVincCodRecolhimento'
        }
        // {
        //   name: 'Consultar',
        //   url: '/usuario/consultar'
        // }
      ]
    }
  ],

  itensAcesso (itens) {
    var i
    var permitidos = new Array()

    // var tokenGrupos = apiCentralSeguranca.decodeJwtToken(store.getters['auth/getJwtToken']).groups
    var tokenGrupos = null

    for (i = 0; i < itens.length; i++) {
      if (itens[i].groups === undefined || itens[i].groups.length === 0) {
        if (itens[i].children !== undefined) {
          itens[i].children = this.itensAcesso(itens[i].children)
        }
        permitidos.push(itens[i])
      } else {
        var y
        for (y = 0; y < tokenGrupos.length; y++) {
          if (itens[i].groups.includes(tokenGrupos[y])) {
            if (itens[i].children !== undefined) {
              itens[i].children = this.itensAcesso(itens[i].children)
            }
            permitidos.push(itens[i])
            break
          }
        }
      }
    }

    return permitidos
  },

  filtrar (itens, pesquisa) {
    pesquisa = pesquisa.toLowerCase()
    var i
    var permitidos = new Array()

    for (i = 0; i < itens.length; i++) {
      var Cadastrar = itens[i].name.toLowerCase().includes(pesquisa)
      if (Cadastrar) {
        permitidos.push(itens[i])
      } else {
        if (itens[i].children !== undefined && itens[i].children.length > 0) {
          if (this.filtrar(itens[i].children, pesquisa).length > 0) {
            permitidos.push(itens[i])
          }
        }
      }
    }

    return permitidos
  }
}
